import { render, staticRenderFns } from "./StorePurchaseForm.vue?vue&type=template&id=12b1cd01"
import script from "./StorePurchaseForm.vue?vue&type=script&lang=js"
export * from "./StorePurchaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports